module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAAQUlEQVQ4y2P4jwQ+MAww7wADDNgPCh5EaHDwGOyBYTQYePx/gFz+QcKDJByGQcH7A3XeIOCBU/Fg4g2OPD14yjoA87Cfm+pUo3gAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDMrMDk6MDB5Ddv1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00318_100x100.png
// module id = U0AS
// module chunks = 0